var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalidades(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6371 3.5H10.9465C9.91783 3.5 9.08398 4.33878 9.08398 5.3735V11.497C9.08398 12.5317 9.91783 13.3705 10.9465 13.3705H20.6371C21.6657 13.3705 22.4996 12.5317 22.4996 11.497V5.3735C22.4996 4.33878 21.6657 3.5 20.6371 3.5Z",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40542 7.06641C6.37642 7.06641 5.54297 7.90476 5.54297 8.93986V15.0634C5.54297 16.0985 6.37642 16.9369 7.40542 16.9369H17.0928C18.1219 16.9369 18.9553 16.0985 18.9553 15.0634V13.3737",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86247 10.6294C2.83346 10.6294 2 11.4678 2 12.5029V18.6263C2 19.6614 2.83346 20.4998 3.86247 20.4998H13.5499C14.5789 20.4998 15.4123 19.6614 15.4123 18.6263V16.9367",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9668 8.95393L14.6726 10.768L18.747 6.40723",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalidades);
export default __webpack_public_path__ + "static/media/modalidades.98dabe5ad10164f1eea66112a6ae5d47.svg";
export { ForwardRef as ReactComponent };